import { useState, useMemo } from "react";
import { ADDONS, ADDON_CONFIG } from "constants/addons";
import { PERIODS } from "constants/pricing";
const DEFAULT_CURRENCY = "usd";
const DEFAULT_PERIOD = PERIODS.yearly;
export const getAddonPricePerUnit = (addon, currency = DEFAULT_CURRENCY, period = DEFAULT_PERIOD)=>{
    var _ADDON_CONFIG_addon;
    const pricePerUnit = (_ADDON_CONFIG_addon = ADDON_CONFIG[addon]) === null || _ADDON_CONFIG_addon === void 0 ? void 0 : _ADDON_CONFIG_addon.pricePerUnit;
    if (!pricePerUnit) {
        return null;
    }
    var _pricePerUnit_period;
    // Return price for the specified period and currency, with fallbacks
    const periodPrices = (_pricePerUnit_period = pricePerUnit[period]) !== null && _pricePerUnit_period !== void 0 ? _pricePerUnit_period : pricePerUnit[DEFAULT_PERIOD];
    if (!periodPrices) {
        return null;
    }
    var _periodPrices_currency, _ref;
    return (_ref = (_periodPrices_currency = periodPrices[currency]) !== null && _periodPrices_currency !== void 0 ? _periodPrices_currency : periodPrices[DEFAULT_CURRENCY]) !== null && _ref !== void 0 ? _ref : null;
};
const useAddon = (addon, currency = DEFAULT_CURRENCY, period = DEFAULT_PERIOD)=>{
    const [addonUnit, setAddonUnit] = useState(()=>{
        const config = ADDON_CONFIG[addon];
        if (config) {
            return config.defaultUnit;
        }
        return null;
    });
    const addonTotalPrice = useMemo(()=>{
        if (!addon || !addonUnit) {
            return null;
        }
        const pricePerUnit = getAddonPricePerUnit(addon, currency, period);
        if (!pricePerUnit) {
            return null;
        }
        return addonUnit * pricePerUnit;
    }, [
        addon,
        addonUnit,
        currency,
        period
    ]);
    return [
        addonUnit,
        setAddonUnit,
        addonTotalPrice
    ];
};
export default useAddon;
